import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

@Injectable()
export class IcosUploadRequest {

  headers: HttpHeaders
  withCredentials: boolean
  fileName: string
  defaultBody: any

  constructor(
    private http: HttpClient,
  ) {
  }

  upload(path: string, file: File): Observable<any> {
    const req: HttpRequest<{}> = new HttpRequest('POST', path, file, {
      headers: this.headers,
      reportProgress: true,
      withCredentials: this.withCredentials,
    })
    return this.http.request(req)
  }

  setHeader(headers: any = {}): IcosUploadRequest {
    this.headers = new HttpHeaders(headers)
    return this
  }

  setCredentials(withCredentials: boolean): IcosUploadRequest {
    this.withCredentials = withCredentials
    return this
  }

  setFileName(name: string): IcosUploadRequest {
    this.fileName = name
    return this
  }

  addExtraData(data: any = {}): IcosUploadRequest {
    this.defaultBody = data
    return this
  }

}

